const EcoEvents = require('./EcoEvents.json');
const LanguageCodes = require('./Languages');
const LanguageStatus = require('./LanguageStatus');
const MultiAccount = require('./multiAccount');
const OtaExecutionState = require('./otaExecutionState');
const PendingActions = require('./pendingActions');
const PhraseEvent = require('./PhraseEvent');
const Season = require('./Season');
const WashingTemperatureRange = require('./washingTemperatureRange');
module.exports = {
  LanguageStatus,
  PhraseEvent,
  Season,
  OtaExecutionState,
  WashingTemperatureRange,
  LanguageCodes,
  MultiAccount,
  EcoEvents,
  PendingActions
};